import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar";
import { LiaAngleLeftSolid } from "react-icons/lia";
import { useNavigate } from "react-router-dom";
import emptyState from "../../Assets/Images/emptyState.png";
import PortfoliosCard from "../Auth/PortfoliosCard";
import PortfolioDateModal from "../../Components/PortfolioDateModal";
import { useDispatch, useSelector } from "react-redux";
import { getPortfolio } from "../../store/actions/portfolio/getportfolio";
import Loader from "../../Components/Utils/Loader";
import { formatAmount } from "../../utils/formatAmount";
import FilterButton from "../../Components/Buttons/FilterButton";
import { getRealEstatePortfolio } from "../../store/actions/portfolio/getRealEstatePortfolio";
// Import the modal

const PortfolioType = ({ back, type, _currency }) => {
  const dispatch = useDispatch();

  const [currency, setCurrency] = useState(
    _currency === "Naira"
      ? { label: "Naira Porfolio", value: "NGR" }
      : { label: "USD Porfolio", value: "USD" },
  );

  const { portfolio: _portfolio, realEstatePortfolio } = useSelector(
    (state) => state.portfolio,
  );

  const portfolio =
    type === "Real Estate"
      ? realEstatePortfolio
      : _portfolio?.map((portfolio) => ({
          ...portfolio,
          investment_category:
            portfolio?.cycle_details?.investmentCategory ||
            portfolio?.cycle_details?.investment_category ||
            portfolio?.investment_category,
        }));

  const Total_Investment =
    type === "Real Estate"
      ? realEstatePortfolio?.reduce((sum, item) => sum + +item?.amount, 0)
      : portfolio?.reduce((sum, item) => sum + +item?.amount, 0);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("Active Investments");
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    if (type === "Real Estate") {
      dispatch(
        getRealEstatePortfolio({
          currency: currency?.value || currency,
          cb: () => {
            setLoading(false);
          },
        }),
      );
    } else {
      dispatch(
        getPortfolio({
          currency: currency?.value || currency,
          cb: () => {
            setLoading(false);
          },
        }),
      );
    }
  }, [currency]);

  return (
    <div className="flex flex-col bg-[#F9FAFA] items-center min-h-screen">
      {/* Navbar */}
      <Navbar type={3} />

      {/* Main Content */}
      <div className="w-[95%] max-w-[1664px] min-h-[80vh] border-[#F2F2F2] border-[1.1px] shadow-md rounded-[12px] bg-[#FFF] p-6 md:p-10 flex flex-col gap-5 mt-5">
        {/* Back Button */}
        <div onClick={back} className="flex cursor-pointer items-center gap-2">
          <LiaAngleLeftSolid size={18} color="#131E3D" />
          <h3 className="text-[14px] font-[400] text-[#131E3D]">Back</h3>
        </div>

        {/* Title and Button */}
        <div className="flex flex-col md:flex-row items-center gap-4 mt-3">
          <div className="text-[36px] md:text-[54px] font-[400] text-[#131e3d]">
            Portfolio
          </div>
        </div>

        {/* Tab Section */}
        {loading && portfolio?.length < 1 ? (
          <div className="h-[50vh] flex justify-center items-center">
            <Loader />
          </div>
        ) : (
          <>
            <div className="sm:w-[330px] border-[#F0F0F5] drop-shadow-custom  p-2 h-[49px] border-[1px] rounded-[41px] flex justify-center items-center">
              <FilterButton
                items={[
                  { label: "Active Investments", value: "Active Investments" },
                  {
                    label: "Paid Out Investments",
                    value: "Paid Out Investments",
                  },
                ]}
                active={activeTab}
                setActive={setActiveTab}
              />
            </div>

            <div className="flex gap-[30px]">
              <div className="mt-0 flex-1">
                {/* <div className=" flex flex-col justify-between p-5 mb-[20px] max-w-[744px] h-[199px] rounded-[12px] border-[1px] border-[#f2f2f7] ">
                  <div className="flex justify-between ">
                    <h4 className=" text-[14px] font-[400] text-[#9c9c9e] ">
                      Investment Balance
                    </h4>
                    <Switcher
                      handleCurrencyChange={setCurrency}
                      label={
                        currency?.value === "NGR"
                          ? "Naira Porfolio"
                          : "USD Porfolio"
                      }
                      options={[
                        { label: "Naira Porfolio", value: "NGR" },
                        { label: "USD Porfolio", value: "USD" },
                      ]}
                    />
                  </div>
                  <div>
                    <h3 className="text-[32px] font-[500] text-[#131E3D] ">
                      {currency?.value === "NGR"
                        ? ngrInvestmentBalance
                        : usdInvestmentBalance}{" "}
                    </h3>
                    <h5 className=" text-[#2CB171] font-[400] text-[14px] ">
                      +{"0"}% gained in the last 30 days
                    </h5>
                  </div>
                </div> */}

                <div className="flex gap- items-start">
                  {activeTab === "Active Investments" ? (
                    <div className="flex w-full justify-start items-center mt-[10px] gap-[20px] flex-wrap">
                      {portfolio?.filter(
                        (item) =>
                          (type === "Real Estate" ||
                            type?.toLowerCase() ===
                              item?.investment_category?.name?.toLowerCase()) &&
                          item?.status == 1,
                      )?.length < 1 ? (
                        <div className="w-full flex-col h-[400px] flex justify-center items-center">
                          <img
                            src={emptyState}
                            alt=""
                            className=" mb-[5px] w-[76px] h-[76px] "
                          />
                          <div className=" mb-[5px] p-2 text-[16px] font-[400] text-[#9C9C9E] ">
                            No Active Investments.
                          </div>
                        </div>
                      ) : (
                        portfolio
                          ?.filter(
                            (item) =>
                              (type === "Real Estate" ||
                                type?.toLowerCase() ===
                                  item?.investment_category?.name?.toLowerCase()) &&
                              item?.status == 1,
                          )
                          ?.map((item, index) => (
                            <PortfoliosCard
                              key={index}
                              category={
                                type === "Real Estate"
                                  ? "Real Estate"
                                  : item?.investment_category?.name
                              }
                              amount={`${
                                currency?.value === "NGR" ? "₦" : "$"
                              }${formatAmount(item?.amount)}`}
                              currency={currency?.value === "NGR" ? "₦" : "$"}
                              break_down={item?.break_down}
                              investment_category={item?.investment_category}
                              owner={
                                item?.property?.name ||
                                item?.cycle_details?.name ||
                                item?.investment_product_name
                              }
                              portfolioPercentage={`${(
                                (item?.amount / Total_Investment) *
                                100
                              ).toFixed(2)}%`}
                              onClick={() => {
                                type === "Real Estate"
                                  ? navigate(
                                      `/investment/realestate/summary/${item?.id}`,
                                      {
                                        state: {
                                          amount: item?.amount,
                                          investment: item,
                                        },
                                      },
                                    )
                                  : navigate(
                                      `/investment-summary/${item?.id}`,
                                      {
                                        state: {
                                          ...item,
                                          __currency: currency?.value,
                                          // adminFee,
                                          // amount,
                                          // id,
                                          // name,
                                          // investment,
                                          // opportunity,
                                          // response,
                                          // campaign,
                                        },
                                      },
                                    );
                              }}
                            />
                          ))
                      )}
                    </div>
                  ) : (
                    <div className="flex w-full justify-start items-center mt-[10px] gap-[20px] flex-wrap">
                      {portfolio?.filter(
                        (item) =>
                          (type === "Real Estate" ||
                            type?.toLowerCase() ===
                              item?.investment_category?.name?.toLowerCase()) &&
                          item?.status == 6,
                      )?.length < 1 ? (
                        <div className="w-full flex-col h-[400px] flex justify-center items-center">
                          <img
                            src={emptyState}
                            alt=""
                            className=" mb-[5px] w-[76px] h-[76px] "
                          />
                          <div className=" mb-[5px] p-2 text-[16px] font-[400] text-[#9C9C9E] ">
                            No Paid Out Investments.
                          </div>
                        </div>
                      ) : (
                        portfolio
                          ?.filter(
                            (item) =>
                              (type === "Real Estate" ||
                                type?.toLowerCase() ===
                                  item?.investment_category?.name?.toLowerCase()) &&
                              (item?.status == 6 || item?.status == "6"),
                          )
                          ?.map((item, index) => (
                            <PortfoliosCard
                              key={index}
                              category={
                                type === "Real Estate"
                                  ? "Real Estate"
                                  : item?.investment_category?.name
                              }
                              amount={`${
                                currency?.value === "NGR" ? "₦" : "$"
                              }${formatAmount(item?.amount)}`}
                              currency={currency?.value === "NGR" ? "₦" : "$"}
                              break_down={item?.break_down}
                              investment_category={item?.investment_category}
                              owner={
                                item?.property?.name ||
                                item?.cycle_details?.name
                              }
                              portfolioPercentage={`${(
                                (item?.amount / Total_Investment) *
                                100
                              ).toFixed(2)}%`}
                              onClick={() => {
                                type === "Real Estate"
                                  ? navigate(
                                      `/investment/realestate/summary/${item?.id}`,
                                      {
                                        state: {
                                          amount: item?.amount,
                                          investment: item,
                                        },
                                      },
                                    )
                                  : navigate(
                                      `/investment-summary/${item?.id}`,
                                      {
                                        state: {
                                          ...item,
                                          __currency: currency?.value,
                                          // adminFee,
                                          // amount,
                                          // id,
                                          // name,
                                          // investment,
                                          // opportunity,
                                          // response,
                                          // campaign,
                                        },
                                      },
                                    );
                              }}
                            />
                          ))
                      )}
                    </div>
                  )}
                  {/* Recent Transactions */}
                  {/* {showTransactionTable ? (
            <TransactionTable />
          ) : (
            <RecentTransaction onClick={() => setShowTransactionTable(true)} />
          )} */}
                </div>
              </div>
              {/* <div className="w-[600px]">
                <div className=" ml-[5px] flex items-center justify-between mb-5 pr-1">
                  <h4 className="font-[500] text-[#131E3D] text-base leading-[17.6px] tracking-[-1%]">
                    Recent Transactions
                  </h4>
                  <FiMoreVertical
                    className="cursor-pointer"
                    size={20}
                    color={"#131E3D"}
                  />
                </div>

                <TransactionTable
                  currency={
                    currency?.value === "NGR" || currency === "NGR"
                      ? "Naira"
                      : "USD"
                  }
                />
              </div> */}
            </div>
          </>
        )}
      </div>

      {/* Modal */}
      {isModalOpen && (
        <PortfolioDateModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)} // Close modal when needed
        />
      )}
    </div>
  );
};

export default PortfolioType;
